const STORAGE_KEY = "production_forecast_daily_sticker_expanded";

export function loadStickerExpandedMap(forecastGroup: string): Record<string, boolean> {
  if (typeof localStorage === "undefined") {
    return {};
  }

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw);
    return parsed?.[forecastGroup] || {};
  } catch {
    return {};
  }
}

export function saveStickerExpandedMap(
  forecastGroup: string,
  expandedMap: Record<string, boolean>
) {
  if (typeof localStorage === "undefined") {
    return;
  }

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    parsed[forecastGroup] = expandedMap;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
  } catch {
    // ignore storage errors
  }
}

export function stickerStateKey(sticker: any): string {
  return String(sticker.sticker_id ?? sticker.sticker_name ?? "none");
}

export function applyStickerExpandedState(
  items: any[],
  forecastGroup: string
): any[] {
  const saved = loadStickerExpandedMap(forecastGroup);

  return items.map((sticker) => {
    const key = stickerStateKey(sticker);
    if (!Object.prototype.hasOwnProperty.call(saved, key)) {
      return sticker;
    }

    return {
      ...sticker,
      expanded: saved[key]
    };
  });
}

export function collectStickerExpandedMap(items: any[]): Record<string, boolean> {
  return items.reduce((acc: Record<string, boolean>, sticker: any) => {
    acc[stickerStateKey(sticker)] = !!sticker.expanded;
    return acc;
  }, {});
}
